import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const TRANSLATIONS = {
  es: {
    nav: {
      home: "Inicio",
      predictions: "Pronósticos",
      markets: "Mercados",
      ranking: "Ranking",
      wallet: "Billetera",
      profile: "Perfil",
      admin: "Admin",
      login: "Entrar",
      register: "Registrarse",
      logout: "Salir",
    },
    common: {
      coins: "USD",
      odds: "Cuota",
      stake: "Stake",
      analysis: "Análisis",
      event: "Evento",
      status: "Estado",
      pending: "Pendiente",
      won: "Ganado",
      lost: "Perdido",
      void: "Anulado",
      open: "Abierto",
      closed: "Cerrado",
      settled: "Liquidado",
      sport: "Deporte",
      all: "Todos",
      football: "Fútbol",
      horse: "Caballos",
      baseball: "Béisbol",
      lottery: "Lotería",
      cancel: "Cancelar",
      save: "Guardar",
      edit: "Editar",
      delete: "Eliminar",
      create: "Crear",
      placeBet: "Apostar",
      balance: "Saldo",
      recharge: "Recargar",
      amount: "Monto",
      method: "Método",
      submit: "Enviar",
      approve: "Aprobar",
      reject: "Rechazar",
      yes: "Sí",
      no: "No",
      sendNotification: "Enviar notificación",
      title: "Título",
      body: "Mensaje",
      enableNotifications: "Activar notificaciones push",
      notificationsEnabled: "Notificaciones activadas",
      bannerAd: "Publicidad",
      noData: "Sin datos",
      back: "Volver",
      continueWithGoogle: "Continuar con Google",
      or: "o",
      email: "Correo",
      password: "Contraseña",
      name: "Nombre",
      welcome: "Bienvenido",
      requestSent: "Solicitud enviada. Esperando aprobación.",
      betOfTheDay: "Apuesta del día",
      welcomeBonus: "¡Bono de bienvenida!",
      youReceived: "Recibiste",
      seeMorePicks: "Ver más pronósticos",
      dontShowAgain: "No mostrar de nuevo hoy",
      close: "Cerrar",
    },
    home: {
      hero1: "Pronósticos de élite.",
      hero2: "Apuestas inteligentes.",
      heroDesc: "Comunidad pro de tipsters y mercados internos para fútbol, caballos, béisbol y loterías. Apuesta con coins virtuales y mide tu ROI.",
      ctaJoin: "Unirme gratis",
      ctaSee: "Ver pronósticos",
      featured: "Destacados",
      latestPicks: "Últimos pronósticos",
      hotMarkets: "Mercados activos",
      sports: "Deportes cubiertos",
    },
    predictions: {
      title: "Pronósticos",
      subtitle: "Picks publicados por el equipo y la comunidad pro.",
      empty: "Aún no hay pronósticos en este deporte.",
      confidence: "Confianza",
    },
    markets: {
      title: "Mercados Prop",
      subtitle: "Apuesta con coins virtuales en mercados rápidos.",
      empty: "Sin mercados abiertos. Vuelve pronto.",
      betWith: "Apostar con",
      potentialPayout: "Pago potencial",
      placedBet: "Apuesta realizada",
    },
    wallet: {
      title: "Billetera",
      subtitle: "Recarga tu saldo para seguir jugando.",
      newRecharge: "Nueva recarga",
      myRecharges: "Mis recargas",
      ratePerDollar: "Equivalencia: 1 USD = $1 USD en saldo.",
      minMax: "Mínimo $5 USD · Máximo $7,000 USD",
      proofNote: "Notas / referencia del pago",
      proofUrl: "URL del comprobante (opcional)",
      pickMethod: "Selecciona método",
    },
    auth: {
      loginTitle: "Inicia sesión",
      registerTitle: "Crea tu cuenta",
      noAccount: "¿No tienes cuenta?",
      haveAccount: "¿Ya tienes cuenta?",
      goRegister: "Regístrate",
      goLogin: "Inicia sesión",
    },
    admin: {
      title: "Panel de administración",
      metrics: "Métricas",
      predictions: "Pronósticos",
      markets: "Mercados",
      banners: "Banners",
      payments: "Métodos de pago",
      recharges: "Recargas",
      users: "Usuarios",
      notifications: "Notificaciones",
      odds: "Datos en vivo",
      bonuses: "Bonos",
      revenue: "Ingresos",
      totalUsers: "Usuarios",
      totalBets: "Apuestas",
      pendingRecharges: "Recargas pendientes",
      openMarkets: "Mercados abiertos",
      newPrediction: "Nuevo pronóstico",
      newMarket: "Nuevo mercado",
      newBanner: "Nuevo banner",
      newMethod: "Nuevo método",
      addOption: "Añadir opción",
      winningOption: "Opción ganadora (vacío = anular)",
      settle: "Liquidar",
      adjustCoins: "Ajustar coins",
      makeAdmin: "Hacer admin",
      makeUser: "Hacer usuario",
      sendToAll: "Enviar a todos",
    },
  },
  en: {
    nav: {
      home: "Home",
      predictions: "Picks",
      markets: "Markets",
      ranking: "Ranking",
      wallet: "Wallet",
      profile: "Profile",
      admin: "Admin",
      login: "Login",
      register: "Sign up",
      logout: "Logout",
    },
    common: {
      coins: "USD",
      odds: "Odds",
      stake: "Stake",
      analysis: "Analysis",
      event: "Event",
      status: "Status",
      pending: "Pending",
      won: "Won",
      lost: "Lost",
      void: "Void",
      open: "Open",
      closed: "Closed",
      settled: "Settled",
      sport: "Sport",
      all: "All",
      football: "Football",
      horse: "Horse",
      baseball: "Baseball",
      lottery: "Lottery",
      cancel: "Cancel",
      save: "Save",
      edit: "Edit",
      delete: "Delete",
      create: "Create",
      placeBet: "Place bet",
      balance: "Balance",
      recharge: "Recharge",
      amount: "Amount",
      method: "Method",
      submit: "Submit",
      approve: "Approve",
      reject: "Reject",
      yes: "Yes",
      no: "No",
      sendNotification: "Send notification",
      title: "Title",
      body: "Message",
      enableNotifications: "Enable push notifications",
      notificationsEnabled: "Notifications enabled",
      bannerAd: "Sponsored",
      noData: "No data",
      back: "Back",
      continueWithGoogle: "Continue with Google",
      or: "or",
      email: "Email",
      password: "Password",
      name: "Name",
      welcome: "Welcome",
      requestSent: "Request sent. Awaiting approval.",
      betOfTheDay: "Bet of the day",
      welcomeBonus: "Welcome bonus!",
      youReceived: "You received",
      seeMorePicks: "See more picks",
      dontShowAgain: "Don't show again today",
      close: "Close",
    },
    home: {
      hero1: "Elite picks.",
      hero2: "Smart prop bets.",
      heroDesc: "Pro tipster community and internal markets for football, horse racing, baseball and lotteries. Bet with virtual coins and measure your ROI.",
      ctaJoin: "Join for free",
      ctaSee: "See picks",
      featured: "Featured",
      latestPicks: "Latest picks",
      hotMarkets: "Live markets",
      sports: "Sports we cover",
    },
    predictions: {
      title: "Predictions",
      subtitle: "Picks posted by our team and pro community.",
      empty: "No picks for this sport yet.",
      confidence: "Confidence",
    },
    markets: {
      title: "Prop Markets",
      subtitle: "Bet virtual coins on fast prop markets.",
      empty: "No open markets. Check back soon.",
      betWith: "Bet with",
      potentialPayout: "Potential payout",
      placedBet: "Bet placed",
    },
    wallet: {
      title: "Wallet",
      subtitle: "Recharge your balance to keep playing.",
      newRecharge: "New recharge",
      myRecharges: "My recharges",
      ratePerDollar: "Rate: 1 USD = $1 USD in balance.",
      minMax: "Min $5 USD · Max $7,000 USD",
      proofNote: "Payment notes / reference",
      proofUrl: "Receipt URL (optional)",
      pickMethod: "Pick method",
    },
    auth: {
      loginTitle: "Sign in",
      registerTitle: "Create account",
      noAccount: "Don't have an account?",
      haveAccount: "Already have an account?",
      goRegister: "Sign up",
      goLogin: "Sign in",
    },
    admin: {
      title: "Admin panel",
      metrics: "Metrics",
      predictions: "Picks",
      markets: "Markets",
      banners: "Banners",
      payments: "Payment methods",
      recharges: "Recharges",
      users: "Users",
      notifications: "Notifications",
      odds: "Live odds",
      bonuses: "Bonuses",
      revenue: "Revenue",
      totalUsers: "Users",
      totalBets: "Bets",
      pendingRecharges: "Pending recharges",
      openMarkets: "Open markets",
      newPrediction: "New pick",
      newMarket: "New market",
      newBanner: "New banner",
      newMethod: "New method",
      addOption: "Add option",
      winningOption: "Winning option (empty = void)",
      settle: "Settle",
      adjustCoins: "Adjust coins",
      makeAdmin: "Make admin",
      makeUser: "Make user",
      sendToAll: "Send to all",
    },
  },
};

const LangContext = createContext({ lang: "es", t: (k) => k, setLang: () => {} });

export function LanguageProvider({ children }) {
  // Detectar idioma del navegador por defecto (ES o EN) si no hay ninguno guardado
  const detectLanguage = () => {
    const saved = localStorage.getItem("pz_lang");
    if (saved) return saved;
    try {
      const browserLang = navigator.language || navigator.userLanguage || "";
      if (browserLang.toLowerCase().startsWith("en")) {
        return "en";
      }
    } catch (e) {}
    return "es"; // Por defecto Español
  };

  const [lang, setLangState] = useState(detectLanguage());

  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem("pz_lang", l);
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let cur = TRANSLATIONS[lang];
      for (const p of parts) {
        cur = cur?.[p];
        if (cur == null) return path;
      }
      return cur;
    },
    [lang]
  );

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
